import { AreaFilterTabItem } from "./types";
import {
  FranchiseType,
  Proposition,
  PropositionAllocation,
} from "@hubcapp/types";

export const getBrandTitle = (
  brand: Proposition["brand"],
  type?: Proposition["type"],
) => {
  if (type && type === FranchiseType.Dit) {
    return "";
  }
  return brand === "AADS" ? "AA" : "BSM";
};

export const getFranchiseTitle = (proposition: Proposition) =>
  `${getBrandTitle(proposition.brand, proposition.type)} ${
    proposition.transmission || ""
  }`.trim();

export const franchiseTypeLabelMap = {
  [FranchiseType.Full]: "Learners",
  [FranchiseType.PartnerLite]: "Learners",
  [FranchiseType.Solo]: "Learners",
  [FranchiseType.Trainee]: "Learners",
  [FranchiseType.ThirdParty]: "Learners",
  [FranchiseType.Dit]: "DIT",
  [FranchiseType.Motability]: "Motability",
};

export const getTabLabel = (
  shouldPrefixProposition = false,
  proposition: Proposition,
): string =>
  `${shouldPrefixProposition ? getFranchiseTitle(proposition) + " " : ""}${
    proposition.type ? franchiseTypeLabelMap[proposition.type] : ""
  }`;

export const buildTabItems = (
  propositionAllocations: Array<PropositionAllocation>,
): Array<AreaFilterTabItem> =>
  propositionAllocations?.map(
    (propositionAllocation: PropositionAllocation) => {
      const isMultipleFranchises = propositionAllocations.length > 1;
      const type = propositionAllocation.proposition.type;
      const testId = type
        ? `areas-covered-tab-${franchiseTypeLabelMap[type].toLowerCase()}`
        : "";

      return {
        ["data-test"]: testId,
        key: propositionAllocation.id,
        label: getTabLabel(
          isMultipleFranchises,
          propositionAllocation.proposition,
        ),
        value: propositionAllocation.id,
      };
    },
  );
